import { render, staticRenderFns } from "./FormButton.vue?vue&type=template&id=c31545ee&scoped=true&"
import script from "./FormButton.vue?vue&type=script&lang=js&"
export * from "./FormButton.vue?vue&type=script&lang=js&"
import style0 from "./FormButton.vue?vue&type=style&index=0&id=c31545ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c31545ee",
  null
  
)

export default component.exports